<template>
  <div>
    <div class="vs-con-loading__container">
      <vs-card style="min-height: 100px" class="px-2" :id="loadingPage">
        <vs-row>
          <vs-col vs-justify="center" vs-align="center" vs-w="6 " vs-xs="12" class="p-2">
            <div class="flex mb-1">
              <label for="">{{ $t('entity') | capitalize }}</label>
            </div>
            <v-select :options="entities" :reduce="(el) => el.id" label="name" v-model="filter.entity" class="w-full"
              @input="getData()" />
          </vs-col>
          <vs-col vs-justify="center" vs-align="center" vs-w="2" vs-xs="12" class="p-2">
            <div class="flex mb-1">
              <label for="">{{ $t('year') | capitalize }}</label>
            </div>
            <v-select :options="years" label="year" v-model="filter.year" class="w-full" @input="getData()" />
          </vs-col>
          <vs-col vs-justify="center" vs-align="center" vs-w="2" vs-xs="12" class="p-2">
            <div class="flex mb-1">
              <label for="">{{ $t('month') | capitalize }}</label>
            </div>
            <v-select :options="months" :reduce="(el) => el.id" :label="$i18n.locale === 'es' ? 'label_es' : 'label_en'"
              v-model="filter.month" class="w-full" @input="getData()" />
          </vs-col>
          <vs-col vs-justify="center" vs-align="center" vs-w="2" vs-xs="12" class="p-2">
            <div class="flex mb-1">
              <label for="">{{ $t('currency') | capitalize }}</label>
            </div>
            <v-select :options="currencies" :reduce="(el) => el.id" label="label" v-model="filter.currency"
              class="w-full" @input="getData()" />
          </vs-col>
        </vs-row>
      </vs-card>

    </div>


    <BudgetDepartamentTable :data="data" :month="month" :loading="loadingTable"/>


  </div>
</template>
<script>
import loading from '@/mixins/Loading'
import vSelect from 'vue-select'
import request from './request.js'
import BudgetDepartamentTable from './components/BudgetDepartamentTable.vue'

export default {
  components: {
    'v-select': vSelect,
    BudgetDepartamentTable,
  },
  computed: {
    isLoading() {
      return (
        this.loading.entities ||
        this.loading.years
      )
    },
  },
  data() {
    return {
      entities: [{ id: '0', name: 'All' }],
      departaments: [],
      years: [],
      months: [
        { id: '1', label_en: 'January', label_es: 'Enero' },
        { id: '2', label_en: 'February', label_es: 'Febrero' },
        { id: '3', label_en: 'March', label_es: 'Marzo' },
        { id: '4', label_en: 'April', label_es: 'Abril' },
        { id: '5', label_en: 'May', label_es: 'Mayo' },
        { id: '6', label_en: 'June', label_es: 'Junio' },
        { id: '7', label_en: 'July', label_es: 'Julio' },
        { id: '8', label_en: 'August', label_es: 'Agosto' },
        { id: '9', label_en: 'September', label_es: 'Septiembre' },
        { id: '10', label_en: 'October', label_es: 'Octubre' },
        { id: '11', label_en: 'November', label_es: 'Noviembre' },
        { id: '12', label_en: 'December', label_es: 'Diciembre' },
      ],
      currencies: [
        { id: 'usd', label: 'USD' },
        { id: 'mxn', label: 'MXN' },
        { id: 'usd_est', label: 'USD EST' }
      ],
      filter: {
        year: null,
        entity: null,
        departament: null,
        month: null,
        currency: null,
      },
      data: [],
      loading: {
        data: false,
        entities: false,
        departaments: false,
        years: false,
      },
      month: '',
      loadingPage: 'budget-entity-loading',
      loadingTable:false
    }
  },
  methods: {
    getEntities() {
      this.loading.entities = true
      request
        .getEntities()
        .then((response) => {
          this.entities = [...this.entities, ...response.data]
          this.loading.entities = false
        })
        .catch((error) => {
          this.loading.entities = false
          this.showValidationErrors(error)
        })
    },
    getYears() {
      this.loading.years = true
      request
        .getYears()
        .then((response) => {
          this.years = response.data.map(function (obj) {
            return obj.year
          })
          this.loading.years = false
        })
        .catch((error) => {
          this.loading.years = false
          this.showValidationErrors(error)
        })
    },
    getData() {
      if (
        this.filter.year !== null &&
        this.filter.entity !== null &&
        this.filter.month !== null &&
        this.filter.currency !== null
      ) {
        this.setMonth()
        this.loadingTable = true
        const payload = {
          year: this.filter.year,
          entity: this.filter.entity,
          departament: this.filter.departament,
          month: this.filter.month,
          currency: this.filter.currency,
        }
        this.data = []
        request
          .list(payload)
          .then((response) => {
            this.data = [...response.data]
            this.loadingTable = false
          })
          .catch((error) => {
            this.loadingTable = false
            this.showValidationErrors(error)
          })
      }
    },
    setMonth() {
      const month = this.months.find((el) => el.id == this.filter.month)
      this.month = this.$i18n.locale === 'es' ? month.label_es : month.label_en
    }
  },
  mixins: [loading],
  mounted() {
    this.getEntities()
    this.getYears()
  },
  watch: {
    isLoading(val) {
      if (val) {
        this.openLoading(this.loadingPage)
      } else {
        this.closeLoading(this.loadingPage)
      }
    },
  },
}
</script>

<style>
.vs__dropdown-menu {
  max-height: 50px;
}
</style>
